module.exports = __webpack_public_path__ + "static/media/cases_brand_jardim_03.f13b5a74.jpg";